import {BaseApiModel} from "../../../infrastructure/models/base-api-model";
import {AthleteDomainModel} from "../../common/athlete/athlete-domain-model";

export class AthletesDataSource extends BaseApiModel {
  athletes: Array<AthleteDomainModel>;

  constructor(athletes: Array<AthleteDomainModel>) {
    super();
    
    this.athletes = athletes;
  }
}
